import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Terms of Service</h1>
          <p className="text-muted-foreground mb-8">Last updated: January 2026</p>
          
          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
              <p className="text-foreground/90 leading-relaxed">
                By accessing and using CallChat's AI phone assistant service, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Service Description</h2>
              <p className="text-foreground/90 leading-relaxed">
                SmartCall AI provides AI-powered call handling, appointment scheduling, and customer communication services for businesses in Belgium and beyond. Our service includes multilingual support (Dutch, French, English, German) and 24/7 availability.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. User Obligations</h2>
              <p className="text-foreground/90 leading-relaxed mb-3">
                As a user of SmartCall AI, you agree to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-foreground/90 ml-4">
                <li>Provide accurate and complete business information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Use the service in compliance with all applicable laws</li>
                <li>Not misuse or attempt to circumvent our systems</li>
                <li>Pay all fees associated with your selected plan</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Subscription and Payments</h2>
              <p className="text-foreground/90 leading-relaxed">
                All plans are billed monthly in advance. We offer a 14-day free trial for new customers. Subscriptions automatically renew unless canceled before the renewal date. Refunds are provided on a case-by-case basis.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Service Availability</h2>
              <p className="text-foreground/90 leading-relaxed">
                While we strive for 99.9% uptime, we cannot guarantee uninterrupted service. Scheduled maintenance will be communicated in advance. We are not liable for service interruptions beyond our reasonable control.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Data and Privacy</h2>
              <p className="text-foreground/90 leading-relaxed">
                Your use of SmartCall AI is also governed by our Privacy Policy. We are committed to GDPR compliance and protecting your data. All data is hosted in Belgian data centers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Intellectual Property</h2>
              <p className="text-foreground/90 leading-relaxed">
                All content, features, and functionality of SmartCall AI are owned by us and protected by international copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Limitation of Liability</h2>
              <p className="text-foreground/90 leading-relaxed">
                SmartCall AI is provided "as is" without warranties of any kind. We shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Termination</h2>
              <p className="text-foreground/90 leading-relaxed">
                Either party may terminate this agreement at any time. Upon termination, you will lose access to the service and your data will be retained according to our Privacy Policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">10. Governing Law</h2>
              <p className="text-foreground/90 leading-relaxed">
                These Terms shall be governed by the laws of Belgium. Any disputes shall be resolved in the courts of Brussels, Belgium.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">11. Contact Information</h2>
              <p className="text-foreground/90 leading-relaxed">
                For questions about these Terms of Service, contact us at:
              </p>
              <div className="mt-4 p-4 bg-secondary/30 rounded-lg">
                <p className="text-foreground/90">Email: hello@smartcall.be</p>
                <p className="text-foreground/90">Address: Brussels, Belgium</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;
